import React from 'react'

import SectionContainer from 'components/atoms/SectionContainer'
import Container from 'components/atoms/Container'
import Row from 'components/atoms/Row'
import Col from 'components/atoms/Col'
import Typography from 'components/atoms/Typography'

import ExplorationCard from 'components/molecules/ExplorationCard'

import config from 'config'

const { assets_url: assetsUrl } = config

const exploreCardData = [
  {
    title: 'campus',
    description: 'Direktori perguruan tinggi terbaik beserta informasi lengkapnya.',
    targetUrl: '/directory',
  },
  {
    title: 'major',
    description: 'Panduan jurusan kuliah terlengkap beserta prospek kariernya di masa depan.',
    targetUrl: 'majors',
  },
  {
    title: 'career',
    description: 'Panduan karier atau profesi di dunia industri terlengkap beserta kisaran gaji.',
    targetUrl: 'careers',
  },
]

const AptitudeExplore = () => (
  <div className="aptitude-explore">
    <SectionContainer
      className="aptitude-explore__section"
      paddingTop={80}
      paddingBottom={120}
    >
      <Container>
        <Typography component="h2" variant="title" className="text-variant-title-sm text-center">
          Eksplorasi Lebih Lanjut
        </Typography>
        <Row>
          {
            exploreCardData.map((item, idx) => (
              <Col md="4" key={`ec-apt-${idx}-${item.title}`}>
                <ExplorationCard {...item} />
              </Col>
            ))
          }
        </Row>
      </Container>
    </SectionContainer>
    <style jsx global>
      {`
        .aptitude-explore {
          &__section {
            background-image: url('${assetsUrl}/assets/img/aptitude/loop-bg.png');
            background-position: center right 60%;
            background-repeat: no-repeat;
            @media screen and (min-width: 576px) {
              background-position: bottom right;
            }
          }
        }
      `}
    </style>
  </div>
)

export default AptitudeExplore
